import i18n from '@/i18n';
import { financial } from '@/utils/permission';

const Layout = () => import('@/layouts/main.vue');
const ReportPayments = () => import('./views/ReportPayments.vue');
const Transactions = () => import('./views/Transactions.vue');
const RevenueSummary = () => import('./views/RevenueSummary.vue');

export default [
  {
    path: 'financial',
    component: Layout,
    meta: { authRequired: true, header: true },
    children: [
      {
        path: 'report-payments',
        name: 'Financial.ReportPayments',
        component: ReportPayments,
        meta: {
          title: i18n.global.t('financial.reportPayments'),
          permission: { module: financial.module, key: financial.showAll },
        },
      },
      {
        path: 'transactions',
        name: 'Financial.Transactions',
        component: Transactions,
        meta: {
          title: i18n.global.t('financial.transactions'),
          permission: { module: financial.module, key: financial.showAll },
        },
      },
      {
        path: 'revenue-summary',
        name: 'Financial.RevenueSummary',
        component: RevenueSummary,
        meta: {
          title: i18n.global.t('financial.revenueSummary'),
          permission: { module: financial.module, key: financial.showAll },
        },
      },
    ],
  },
];
